import React from 'react';
import styles from './IconButton.module.css';
import cn from 'classnames';

const IconButton = ({
	children,
	onClick,
	disabled,
	className,
	...rest
}) => {
	const handleClick = (e) => {
		if (disabled) {
			e.preventDefault();
			return;
		}
		if (onClick) {
			onClick();
		}
	};

	return (
		<button
			type="button"
			className={cn(styles.iconButton, className)}
			disabled={disabled}
			onClick={handleClick}
			{...rest}
		>
			{children}
		</button>
	);
};

export default IconButton;
